var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSimpleStepsIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5043_5200",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 75,
    height: 75
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 75,
    height: 75,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5043_5200)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.125 53.125H40.625C42.3438 53.125 43.8151 52.513 45.0391 51.2891C46.263 50.0651 46.875 48.5938 46.875 46.875V42.1875C46.875 40.8333 46.4323 39.7135 45.5469 38.8281C44.6615 37.9427 43.5417 37.5 42.1875 37.5C43.5417 37.5 44.6615 37.0573 45.5469 36.1719C46.4323 35.2865 46.875 34.1667 46.875 32.8125V28.125C46.875 26.4062 46.263 24.9349 45.0391 23.7109C43.8151 22.487 42.3438 21.875 40.625 21.875H28.125V28.125H40.625V34.375H34.375V40.625H40.625V46.875H28.125V53.125ZM15.625 65.625C13.9062 65.625 12.4349 65.013 11.2109 63.7891C9.98698 62.5651 9.375 61.0938 9.375 59.375V15.625C9.375 13.9062 9.98698 12.4349 11.2109 11.2109C12.4349 9.98698 13.9062 9.375 15.625 9.375H59.375C61.0938 9.375 62.5651 9.98698 63.7891 11.2109C65.013 12.4349 65.625 13.9062 65.625 15.625V59.375C65.625 61.0938 65.013 62.5651 63.7891 63.7891C62.5651 65.013 61.0938 65.625 59.375 65.625H15.625Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSimpleStepsIcon1);
export default __webpack_public_path__ + "static/media/SimpleStepsIcon1.ce68ef793766da83e474a8551122c695.svg";
export { ForwardRef as ReactComponent };